// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

/** Brazil */
const BR: PhoneNumberData = [55, 'BR', 10, '00 0000-0000', 11, '00 00000-0000'];

export default BR;
